import React, { useContext } from 'react'
import { ThemeContext } from './themecontext/ThemeContext'

export default function MovieCard(prop) {
    let {theme}=useContext(ThemeContext)
    let movie=prop.movieDetail
    return (
        <div className={`card mt-4 p-3 ${theme === "dark" ? "bg-dark text-light border-secondary" : "bg-light text-dark"}`}>
            <div className="row g-3 align-items-center">
                <div className="col-12 col-md-4 text-center">
                    <img src={movie.Poster} alt="poster" className="img-fluid rounded" style={{ maxHeight: "350px" }}/>
                </div>
                <div className="col-12 col-md-8">
                    <h4>{movie.Title}</h4>
                    <p><b>Year:</b> {movie.Year}</p>
                    <p><b>Genre:</b> {movie.Genre}</p>
                    <p><b>Director:</b> {movie.Director}</p>
                    <p><b>Actors:</b> {movie.Actors}</p>
                    <p><b>IMDB Rating:</b> ⭐ {movie.imdbRating}</p>
                </div>
            </div>
        </div>
    )
}